// extracted by mini-css-extract-plugin
export default {"formHeading":"MH-z","form":"NH-z","submitBtn":"OH-z","disabled":"PH-z","input":"QH-z","error":"RH-z","submitMsg":"SH-z","signIn":"TH-z"};